import Validation from "@irati/utils/validation";
export var poNumberSchema = Validation.string().max(255);
